import { URLS } from "utils/constants";

export const getPostLoginRedirect = (user) => {
  const roles = user?.roles?.map((role) => role.name) || [];

  if (roles.includes("resto")) {
    return URLS.v1.POS;
  }

  if (roles.includes("host")) {
    return URLS.v1.BOOKINGV4;
  }

  return URLS.v1.DASHBOARD;
};
